import angular from 'angular'
import directive from './directive'

export default angular
  .module('ellipsis.quotePropertyEditor', [])
  .directive('quotePropertyEditor', directive)
